import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=e5b559ae&scoped=true&"
import script from "./Friends.vue?vue&type=script&lang=js&"
export * from "./Friends.vue?vue&type=script&lang=js&"
import style0 from "./Friends.vue?vue&type=style&index=0&id=e5b559ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b559ae",
  null
  
)

export default component.exports